import GoldenLayout from '@deephaven/golden-layout';
import PanelManager from "./PanelManager.js";
export { isWrappedComponent } from '@deephaven/components';

/**
 * Panel components can provide static props that provide meta data about the
 * panel.
 */

/**
 * Alias for the return type of React.forwardRef()
 */

/**
 * @deprecated Use `PanelComponentType` instead and add generic types to forwardRef call.
 */

/**
 * Props with metadata, panelState, GoldenLayout props, but not dashboardId
 */

/**
 * Props with metadata, panelState, dashboardId, and GoldenLayout props
 */

/**
 * Props with metadata, panelState, and dashboardId, but not GoldenLayout props
 */

/**
 * Takes a partial DashboardPluginComponentProps and verifies all the dashboard component fields are filled in.
 * @param props The props to check
 * @returns True if the props are valid DashboardPluginComponentProps, false otherwise
 */
export function isDashboardPluginProps(props) {
  return typeof props.id === 'string' && props.layout instanceof GoldenLayout && props.panelManager instanceof PanelManager && typeof props.registerComponent === 'function';
}
export function assertIsDashboardPluginProps(props) {
  if (!isDashboardPluginProps(props)) {
    throw new Error("Expected dashboard plugin props, but instead received ".concat(props));
  }
}
//# sourceMappingURL=DashboardPlugin.js.map